import { CreatedByRelationship } from './Common'

export const resourceMapSF = {
  direction: 'in',
  ...CreatedByRelationship,
  Id: 'id',
  Stage__c: 'stage'
}

export interface Resource {
  stage: string
  id: string
}
